import type { MeetingPublic } from '@repo/types/meetings';
import type { DatetimeCursorPagination } from '@repo/types/pagination';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { EditMeetingData } from './meetingService';

import { MeetingKey } from './keys';
import { MeetingService } from './meetingService';

export function useEditMeeting(params?: DatetimeCursorPagination) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: EditMeetingData) => MeetingService.editMeeting(data).then((response) => response.data),
    onSuccess: (data) => {
      queryClient.setQueryData([MeetingKey.MEETINGS, data.id], (prev?: MeetingPublic) => {
        if (!prev) return;
        return {
          ...prev,
          ...data,
        };
      });
    },
    onSettled: (data) => {
      if (data) {
        queryClient.invalidateQueries({
          queryKey: [MeetingKey.MEETINGS, data.id],
        });
        queryClient.invalidateQueries({
          queryKey: [MeetingKey.MEETINGS, params],
        });
      }
    },
  });
}
